import React from 'react';
import { EditControl } from 'react-leaflet-draw';

const EditControlWrapper = React.forwardRef((props, ref) => {
  return <EditControl {...props} ref={ref} />;
});

EditControlWrapper.displayName = 'EditControlWrapper';

export default EditControlWrapper; 